import React from 'react';

const LeadPositionPattern = ({ className }) => {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" width="1442" height="520" viewBox="0 0 1442 520" fill="none">
      <circle opacity="0.35" cx="655" cy="382" r="20" fill="#DDCAEB" />
      <circle opacity="0.35" cx="740" cy="330" r="20" fill="#DDCAEB" />
      <circle opacity="0.18" cx="1400" cy="31" r="26" fill="#DDCAEB" stroke="#7F4A9B" stroke-width="10" />
      <circle opacity="0.35" cx="1296" cy="62" r="20" fill="#DDCAEB" />
      <circle opacity="0.35" cx="1006" cy="69" r="20" fill="#DDCAEB" />
      <path opacity="0.29" d="M669.5 0C669.5 113 540.5 200 421 117L301 0H669.5Z" fill="#7F4A9B" />
      <path opacity="0.29" d="M1343.5 178.002C1232.5 102.5 1045 207.499 1131.5 390.5L1264.5 518.502H1441V268.002L1343.5 178.002Z" fill="#7F4A9B" />
      <path opacity="0.29" d="M445.5 36.0015C555 176 386.5 344.499 239.5 242.001L0 0H409.499L445.5 36.0015Z" fill="#A971C7" />
      <path opacity="0.29" d="M1441.29 519.498H1079.79C985.933 333.75 1180.31 232.569 1300.79 310.498C1306.26 314.034 1396.29 402.164 1441.29 450.998V519.498Z" fill="#A971C7" />
    </svg>
  );
};

export default LeadPositionPattern;